import { TextField as MuiTextField, TextFieldProps } from '@mui/material'

export const TextField = (props: TextFieldProps) => <MuiTextField {...props} />